import { escapeHtml } from './core.js';

/*
 * Helpers shared by the cockpit primitives (Button, Badge, Card,
 * SectionHeader, EmptyState). Each primitive has one markup builder used by
 * both the live component and renderStatic(), so the two cannot drift.
 */

/** Joins class names, skipping falsy entries. */
export function cx(...parts) { return parts.filter(Boolean).join(' '); }

/** Picks `value` when it is one of `allowed`, else `fallback`. */
export function pick(value, allowed, fallback) { return allowed.includes(value) ? value : fallback; }

/** Attribute string (leading space) from an object; null/undefined/false are skipped, true is a bare attribute. */
export function attrs(map) {
	let out = '';
	for (const [k, v] of Object.entries(map)) {
		if (v === undefined || v === null || v === false) continue;
		out += v === true ? ` ${k}` : ` ${k}="${escapeHtml(v)}"`;
	}
	return out;
}

/** Parses builder markup and puts its root element in place of the component's placeholder root. */
export function mountRoot(comp, html) {
	const tpl = document.createElement('template');
	tpl.innerHTML = html.trim();
	const next = tpl.content.firstElementChild;
	next.id = comp.id;
	if (comp.options.className) String(comp.options.className).split(/\s+/).filter(Boolean).forEach((c) => next.classList.add(c));
	if (comp.options.theme) next.setAttribute('data-theme', comp.options.theme);
	const old = comp.el;
	if (old && old.parentNode) old.parentNode.replaceChild(next, old);
	comp.el = next;
	return next;
}

/** Wires clicks on [data-dfc-action] descendants to an `action` event and the onAction callback. */
export function bindActions(comp) {
	comp.el.addEventListener('click', (e) => {
		const btn = e.target.closest && e.target.closest('[data-dfc-action]');
		if (!btn || !comp.el.contains(btn) || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
		const payload = { id: btn.getAttribute('data-dfc-action'), event: e };
		comp.emit('action', payload);
		if (typeof comp.options.onAction === 'function') comp.options.onAction(payload);
	});
}
